import styled, { css } from "styled-components";
import buildColor from "@tvg/atomic-ui/_static/ColorPalette";
import {
  fontNormal,
  fontMedium,
  defaultSize
} from "@tvg/atomic-ui/_static/Typography";

export const filterButtonSelected = (calendar: boolean) =>
  calendar
    ? css`
        background-color: ${buildColor("blue_accent", "100")};
        border-color: ${buildColor("blue", "100")};
      `
    : css`
        background-color: ${buildColor("blue_accent", "100")};
        border-color: ${buildColor("blue_accent", "500")};
        color: ${buildColor("blue_accent", "700")};
      `;

export const FiltersContainer = styled.div<{
  calendar?: boolean;
}>`
  display: flex;
  border: 1px solid ${buildColor("blue", "100")};
  border-radius: 3px;
  margin: 14px 8px 14px 0;
  box-shadow: 0 2px 2px rgba(17, 43, 68, 0.15);
  align-items: center;
  ${({ calendar }) =>
    calendar &&
    css`
      z-index: 2;
    `}
`;

export const FilterButton = styled.button<{
  selected?: boolean;
  calendar?: boolean;
}>`
  box-sizing: content-box;
  padding: 0 12px;
  border: 1px solid transparent;
  border-radius: 2px;
  font-family: ${fontMedium};
  background-color: transparent;
  color: ${buildColor("black", "70")};
  cursor: pointer;
  height: 26px;
  display: flex;
  align-items: center;
  gap: 9px;
  ${({ selected, calendar }) =>
    selected
      ? filterButtonSelected(!!calendar)
      : css`
          & :hover {
            background-color: ${buildColor("blue_accent", "000")};
            border-color: ${buildColor("blue", "100")};
          }
        `}
`;

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 0 10px;
`;

export const DateSpan = styled.span<{
  value: Date;
}>`
  padding-left: 8px;
  color: ${buildColor("grey", "700")};
  ${({ value }) =>
    value &&
    css`
      color: ${buildColor("grey", "900")};
    `};
`;

export const Divider = styled.div`
  height: 16px;
  display: flex;
  align-items: center;
  border-left: 1px solid ${buildColor("blue_accent", "100")};
`;

export const DatePickerOverlay = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  margin-top: -45px;
  margin-left: -25px;
  z-index: -1;
`;

export const DatePickerWrapper = styled.div`
  position: absolute;
  margin-top: 46px;
  background: ${buildColor("white", "100")};
  border: 1px solid ${buildColor("blue", "100")};
  box-sizing: border-box;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.14);
  border-radius: 4px;
  min-height: 322px;
  z-index: 1;
`;

// TODO: this is the default styles file minified, it's a workaround. We are currently exploring options with our css webpack plugin.
// Whenever you are changing or bumping react-day-picker, please make sure to update this string as well.
const MinifiedDayPickerDefaultStyles =
  ".DayPicker{display:inline-block;font-size:1rem}.DayPicker-wrapper{position:relative;flex-direction:row;padding-bottom:1em;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.DayPicker-Months{display:flex;flex-wrap:wrap;justify-content:center}.DayPicker-Month{display:table;margin:0 1em;margin-top:1em;border-spacing:0;border-collapse:collapse;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.DayPicker-NavButton{position:absolute;top:1em;right:1.5em;left:auto;display:inline-block;margin-top:2px;width:1.25em;height:1.25em;background-position:center;background-size:50%;background-repeat:no-repeat;color:#8b9898;cursor:pointer}.DayPicker-NavButton:hover{opacity:.8}.DayPicker-NavButton--prev{margin-right:1.5em;background-image:url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAwCAYAAAB5R9gVAAAABGdBTUEAALGPC/xhBQAAAVVJREFUWAnN2G0KgjAYwPHpGfRkaZeqvgQaK+hY3SUHrk1YzNLay/OiEFp92I+/Mp2F2Mh2lLISWnflFjzH263RQjzMZ19wgs73ez0o1WmtW+dgA01VxrE3p6l2GLsnBy1VYQOtVSEH/atCCgqpQgKKqYIOiq2CBkqtggLKqQIKgqgCBjpJ2Y5CdJ+zrT9A7HHSTA1dxUdHgzCqJIEwq0SDsKsEg6iqBIEoq/wEcVRZBXFV+QJxV5mBtlDFB5VjYTaGZ2sf4R9PM7U9ZU+lLuaetPP/5Die3ToO1+u+MKtHs06qODB2zBnI/jBd4MPQm1VkY79Tb18gB+C62FdBFsZR6yeIo1YQiLJWMIiqVjQIu1YSCLNWFgijVjYIuhYYCKoWKAiiFgoopxYaKLUWOii2FgkophYp6F3r42W5A9s9OcgNvva8xQaysKXlFytoqdYmQH6tF3toSUo0INq9AAAAAElFTkSuQmCC')}.DayPicker-NavButton--next{background-image:url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAwCAYAAAB5R9gVAAAABGdBTUEAALGPC/xhBQAAAXRJREFUWAnN119ugjAcwPHWzJ1gnmxzB/BBE0n24m4xfNkTaOL7wOtsl3AXMMb+Vjaa1BG00N8fSEibPpAP3xAKKs2yjzTPH9RAjhEo9WzPr/Vm8zgE0+gXATAxxuxtqeJ9t5tIwv5AtQAApsfT6TPdbp+kUBcgVwvO51KqVhMkXKsVJFXrOkigVhCIs1Y4iKlWZxB1rX4gwlpRIIpa8SDkWmggrFq4IIRaJKCYWnSgnrXIQV1r8YD+1Vrn+bReagysIFfLABRt31v8oBu1xEBttfRbltmfjgEcWh9snUS2kNdBK6WN1vrOWxObWsz+fjxevsxmB1GQDfINWiev83nhaoiB/CoOU438oPrhXS0WpQ9xc1ZQWxWHqUYe0I0qrKCQKjygDlXIQV2r0IF6ViEBxVTBBSFUQQNhVYkHIVeJAtkNsbQ7c1LtzP6FsObhb2rCKv7NBIGoq4SDmKoEgTirXAcJVGkFSVVpgoSrXICGUMUH/QBZNSUy5XWUhwAAAABJRU5ErkJggg==')}.DayPicker-NavButton--interactionDisabled{display:none}.DayPicker-Caption{display:table-caption;margin-bottom:.5em;padding:0 .5em;text-align:left}.DayPicker-Caption>div{font-weight:500;font-size:1.15em}.DayPicker-Weekdays{display:table-header-group;margin-top:1em}.DayPicker-WeekdaysRow{display:table-row}.DayPicker-Weekday{display:table-cell;padding:.5em;color:#8b9898;text-align:center;font-size:.875em}.DayPicker-Weekday abbr[title]{border-bottom:none;text-decoration:none}.DayPicker-Body{display:table-row-group}.DayPicker-Week{display:table-row}.DayPicker-Day{display:table-cell;padding:.5em;border-radius:50%;vertical-align:middle;text-align:center;cursor:pointer}.DayPicker-WeekNumber{display:table-cell;padding:.5em;min-width:1em;border-right:1px solid #eaecec;color:#8b9898;vertical-align:middle;text-align:right;font-size:.75em;cursor:pointer}.DayPicker--interactionDisabled .DayPicker-Day{cursor:default}.DayPicker-Footer{padding-top:.5em}.DayPicker-TodayButton{border:none;background-color:transparent;background-image:none;box-shadow:none;color:#4a90e2;font-size:.875em;cursor:pointer}.DayPicker-Day--today{color:#d0021b;font-weight:700}.DayPicker-Day--outside{color:#8b9898;cursor:default}.DayPicker-Day--disabled{color:#dce0e0;cursor:default}.DayPicker-Day--sunday{background-color:#f7f8f8}.DayPicker-Day--sunday:not(.DayPicker-Day--today){color:#dce0e0}.DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside){position:relative;background-color:#4a90e2;color:#f0f8ff}.DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside):hover{background-color:#51a0fa}.DayPicker:not(.DayPicker--interactionDisabled) .DayPicker-Day:not(.DayPicker-Day--disabled):not(.DayPicker-Day--selected):not(.DayPicker-Day--outside):hover{background-color:#f0f8ff}.DayPickerInput{display:inline-block}.DayPickerInput-OverlayWrapper{position:relative}.DayPickerInput-Overlay{position:absolute;left:0;z-index:1;background:#fff;box-shadow:0 2px 5px rgba(0,0,0,.15)}";

export const DayPickerCustomStyles = (
  from: Date | undefined,
  to: Date | undefined,
  isSameDate: boolean
) => `
  ${MinifiedDayPickerDefaultStyles}
  .DayPicker {
    font-family: ${fontNormal};
    font-size: ${defaultSize};
  }
  .DayPicker-Caption {
    font-family: ${fontMedium};
    font-size: ${defaultSize};
    color: ${buildColor("grey", "900")};
  }
  .DayPicker-Month {
    margin: 24px 24px 0;
    border-collapse: separate;
    border-spacing: 8px;
  }
  .DayPicker-NavBar {
    position: absolute;
    right: 24px;
    top: 24px;
  }
  .DayPicker-NavBarElement {
    border-radius: 2px;
    box-shadow: 0px 2px 2px rgba(17, 43, 68, 0.15);
  }
  .DayPicker-NavBarElement > button:hover {
    background: transparent;
  }
  .DayPicker-NavBarElement > button:active {
    background: ${buildColor("blue_accent", "100")};
  }
  .DayPicker-Week {
    height: 24px;
  }
  .DayPicker-Day {
    padding: 0;
    font-size: ${defaultSize};
    width: 32px;
    height: 32px;
  }
  .DayPicker-Day:not(.DayPicker-Day--disabled):not(.DayPicker-Day--selected):not(.DayPicker-Day--outside):hover {
    border-radius: 50% !important;
    background-color: ${buildColor("blue", "100")} !important;
    color: ${buildColor("grey", "900")} !important;
  }
  .DayPicker-Day--secondaryDate:not(.DayPicker-Day--today):not(.DayPicker-Day--outside), .DayPicker-Day--secondaryDate:not(.DayPicker-Day--today):not(.DayPicker-Day--outside):hover {
    background-color: ${buildColor("blue_accent", "500")} !important;
    color: white;
  }
  .DayPicker-Day--today:not(.DayPicker-Day--outside) {
    border-radius: 50% !important;
    border: 1px solid ${buildColor("blue_accent", "500")};
    background: transparent;
    color: ${buildColor("grey", "900")};
    font-weight: normal !important;
  }
  .DayPicker-Weekday {
    font-family: ${fontMedium};
    color: ${buildColor("grey", "700")};
  }
  .DayPicker-Day--disabled {
    color: ${buildColor("grey", "600")};
  }
  .DayPicker-Day--selected:not(.DayPicker-Day--outside) {
    background-color: ${buildColor("blue_accent", "500")} !important;
  }
  .DayPicker-Day--selected:not(.DayPicker-Day--start):not(.DayPicker-Day--end):not(.DayPicker-Day--outside) {
    border-radius: 0 !important;
    background-color: ${buildColor("blue_accent", "100")} !important;
    color: ${buildColor("grey", "900")};
    box-shadow: -4px 0 0 0 ${buildColor(
      "blue_accent",
      "100"
    )}, 4px 0 0 0 ${buildColor("blue_accent", "100")}; 
  }
  .DayPicker-Day--selected:not(.DayPicker-Day--start):not(.DayPicker-Day--end):not(.DayPicker-Day--outside):hover {
    background-color: ${buildColor("blue", "100")} !important;
    box-shadow: -4px 0 0 0 ${buildColor("blue", "100")}, 
                4px 0 0 0 ${buildColor("blue", "100")}; 
  }
  .DayPicker-Day.DayPicker-Day--end.DayPicker-Day--selected, .DayPicker-Day.DayPicker-Day--start.DayPicker-Day--selected {
    border: none !important;
  }
  .DayPicker-Day--start {
    border-radius: 50% !important;
  }
  .DayPicker-Day--end {
    border-radius: 50% !important;
  }
  ${
    !!from &&
    !!to &&
    !isSameDate &&
    `.DayPicker-Day--end.DayPicker-Day--selected:not(.DayPicker-Day--outside)::before {
      content: " ";
      position: absolute;
      height: 100%;
      width: 100%;
      top: 0;
      left: 0;
      background-color: ${buildColor("blue_accent", "100")} !important;
      border-top-right-radius: 50% !important;
      border-bottom-right-radius: 50% !important;
      box-shadow: -4px 0 0 0 ${buildColor("blue_accent", "100")};
      z-index: -1;
    }
  
   .DayPicker-Day--start.DayPicker-Day--selected:not(.DayPicker-Day--outside)::before {
      content: " ";
      position: absolute;
      height: 100%;
      width: 100%;
      top: 0;
      left: 0;
      background-color: ${buildColor("blue_accent", "100")} !important;
      border-top-left-radius: 50% !important;
      border-bottom-left-radius: 50% !important;
      box-shadow: 4px 0 0 0 ${buildColor("blue_accent", "100")};
      z-index: -1;
    }`
  }
`;
